import React from 'react';
import { Link } from 'react-router-dom';
import { LoopLogo } from './cartoon/Art';
import { contact, sectionLinks, talkLink } from './cartoon/links';
import { POLICIES } from '../pages/policies/content';

export default function Footer() {
    const ano = new Date().getFullYear();

    return (
        <footer className="lc lc-footer">
            <div className="lc-wrap">
                <div className="lc-footer-cols">
                    <div>
                        <div style={{ width: 190 }}><LoopLogo /></div>
                        <p style={{ marginTop: 20, fontSize: 18, fontWeight: 700 }}>
                            Beba. Inspire. Repita<span style={{ color: 'var(--lc-verm)' }}>.</span>
                        </p>
                        <p style={{ marginTop: 6, color: '#bbb' }}>Café especial pra todos.</p>
                    </div>
                    <div>
                        <nav aria-label="Rodapé">
                            <h3>NAVEGUE</h3>
                            <ul>
                                {sectionLinks.map((link) => (
                                    <li key={link.href}><a href={link.href}>{link.label}</a></li>
                                ))}
                            </ul>
                        </nav>
                        {/* Shares the column with NAVEGUE: the footer grid has three columns. */}
                        <nav aria-label="Políticas" style={{ marginTop: 32 }}>
                            <h3>POLÍTICAS</h3>
                            <ul>
                                {POLICIES.map((policy) => (
                                    <li key={policy.path}><Link to={policy.path}>{policy.label}</Link></li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                    <div>
                        <h3>FALE COM A GENTE</h3>
                        <ul>
                            <li><a href={talkLink} target="_blank" rel="noopener noreferrer">WhatsApp {contact.phone}</a></li>
                            <li><a href={contact.emailHref}>{contact.email}</a></li>
                            <li><a href={contact.instagramUrl} target="_blank" rel="noopener noreferrer">Instagram {contact.instagram}</a></li>
                        </ul>
                    </div>
                </div>
                <div className="lc-footer-bottom">
                    <span>© {ano} Loop Coffee. Todos os direitos reservados.</span>
                    <a href="#inicio" style={{ fontWeight: 700, letterSpacing: 2 }}>CONTINUAR? ▲ voltar ao topo</a>
                </div>
            </div>
        </footer>
    );
}
